import { render, staticRenderFns } from "./MessageBox.vue?vue&type=template&id=851d42c4&"
import script from "./MessageBox.vue?vue&type=script&lang=js&"
export * from "./MessageBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('851d42c4')) {
      api.createRecord('851d42c4', component.options)
    } else {
      api.reload('851d42c4', component.options)
    }
    module.hot.accept("./MessageBox.vue?vue&type=template&id=851d42c4&", function () {
      api.rerender('851d42c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/atoms/Messagebox/MessageBox.vue"
export default component.exports